import './css/common.less';
import './css/subcommon.less';
import './css/infomation.less';

if (process.env.NODE_ENV !== 'production') {
  require('./infomation.pug');
}



// WEBPACK FOOTER //
// ./src/infomation.js